<template>
  <div id="app">
    <div class="m-auto max-w-5xl w-full shadow-lg print:shadow-none">
        <div class="header-seguimientos w-full h-32 flex bg-cover bg-white text-center overflow-hidden" title="Cotizaciones">
            <div class="w-full flex p-4 items-center justify-between">
                <span class="bikesport-title text-2xl text-white ml-auto">Seguimiento de Cotizaciones</span>
            </div>
        </div>

      <div
        id="app-content"
        v-cloak
        class="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white p-4 flex flex-col justify-between leading-normal"
      >
        <navbar></navbar>

        <router-view />

        <ui-loader></ui-loader>
      </div>
    </div>

    <p class="text-center text-gray-500 text-xs mt-8">
      ©{{ anio }} Seguimiento de Cotizaciones.
    </p>
  </div>
</template>
<script>
import UiLoader from "./components/UiLoader";
import Navbar from "./components/Navbar";

export default {
  components: { Navbar, UiLoader },
  computed: {
    anio: () => new Date().getFullYear()
  },
  created() {
    // ...
  }
};
</script>
<style>
.header-seguimientos {
  background-image: url("assets/banner-cotizaciones.jpg");
}
</style>
